// Un en-tête de colonne qui trie : un clic dans le sens naturel de la colonne
// (les dates et les montants du plus grand au plus petit, les textes de A à Z),
// un second clic dans l'autre sens.

import type { SensTri, Tri } from '@imp/shared/liste-triee';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

import { cn } from '@/lib/utils';

export function EnteteTriable<K extends string>({
  cle,
  libelle,
  tri,
  onTrier,
  sensNaturel = 'asc',
  aDroite = false,
  className,
}: {
  cle: K;
  libelle: string;
  tri: Tri<K>;
  onTrier: (cle: K, sensNaturel: SensTri) => void;
  sensNaturel?: SensTri;
  aDroite?: boolean;
  className?: string;
}) {
  const actif = tri.cle === cle;
  const Icone = !actif ? ArrowUpDown : tri.sens === 'asc' ? ArrowUp : ArrowDown;
  return (
    <th
      className={cn('px-4 py-3 font-medium', aDroite && 'text-right', className)}
      aria-sort={actif ? (tri.sens === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        onClick={() => {
          onTrier(cle, sensNaturel);
        }}
        className={cn(
          'hover:text-foreground inline-flex items-center gap-1 uppercase',
          actif && 'text-foreground',
          aDroite && 'flex-row-reverse',
        )}
      >
        {libelle}
        <Icone className={cn('h-3.5 w-3.5', !actif && 'opacity-40')} aria-hidden />
      </button>
    </th>
  );
}
